import React from 'react';
import PropTypes from 'prop-types';

import SectionHeading from '../../../../text/SectionHeading';

import styles from './style.module.scss';

const RankingsListHeader = ({ handleViewAllClick, title }) => (
    <div className={styles.container}>
        <SectionHeading title={title} />
        <p className="link clickable" onClick={handleViewAllClick}>View All</p>
    </div>
);

RankingsListHeader.propTypes = {
    handleViewAllClick: PropTypes.func.isRequired,
    title: PropTypes.string,
};

RankingsListHeader.defaultProps = {
    title: '',
};

export default RankingsListHeader;
